module.exports = __webpack_public_path__ + "media/bootstrap-icons/image-alt-45582968.svg";